export function empty(value?: string): value is undefined {
  return !value || !value.trim();
}
